(() => {
  "use strict";
  const model = globalThis.JazzisMix;
  if (!model) return;
  const root = window.Shopify?.routes?.root || "/";
  document.querySelectorAll("[data-mix-builder]").forEach(form => {
    const size = form.querySelector("[data-mix-size]");
    const boxStyle = form.querySelector("[data-mix-box-style]");
    const productOptions = [...form.querySelectorAll("[data-mix-product-option]")];
    const matchesProductOptions = option => productOptions.every(control =>
      option?.dataset[`option${control.dataset.optionPosition}`] === control.value);
    const restoreProductOptions = option => productOptions.forEach(control => {
      const value = option?.dataset[`option${control.dataset.optionPosition}`];
      if (value !== undefined) control.value = value;
    });
    const itemNoun = form.dataset.itemNoun === "item" ? "item" : form.dataset.itemNoun === "box" ? "box" : "bag";
    // Legacy flag identifies Christmas containers; their total is now capped.
    const unlimitedPicks = form.dataset.unlimitedPicks === "true";
    const maxChristmasPicks = 20;
    const rows = [...form.querySelectorAll("[data-mix-sweet]")];
    const status = form.querySelector("[data-mix-status]");
    const summary = form.querySelector("[data-mix-summary]");
    const selectedPicks = form.querySelector("[data-mix-picks]");
    const price = form.querySelector("[data-mix-price]");
    const priceSummary = form.querySelector("[data-mix-price-summary]");
    const totalOutput = form.querySelector("[data-mix-total]");
    const designImage = form.querySelector("[data-mix-design-image]");
    const designCaption = form.querySelector("[data-mix-design-caption]");
    const surchargeNote = form.querySelector("[data-bubs-surcharge-note]");
    const search = form.querySelector("[data-mix-search]");
    const bagTypeSwitch = form.querySelector("[data-bag-type-switch]");
    const progress = form.querySelector("[data-mix-progress]");
    const progressCopy = form.querySelector("[data-mix-progress-copy]");
    const portionsCopy = form.querySelector("[data-mix-portions]");
    const emptyResults = form.querySelector("[data-mix-empty]");
    const add = form.querySelector("[data-mix-add]");
    const addLabel = form.querySelector("[data-mix-add-label]");
    const addPrice = form.querySelector("[data-mix-add-price]");
    const shippingNode = form.querySelector("[data-mix-shipping-progress]");
    const shippingMessage = form.querySelector("[data-mix-shipping-message]");
    const shippingCompactMessage = form.querySelector("[data-mix-shipping-compact-message]");
    const shippingMeter = form.querySelector("[data-mix-shipping-meter]");
    const shippingFill = form.querySelector("[data-mix-shipping-fill]");
    const shippingProgress = window.JazzisCartShippingProgress;
    const bagQuantityOutput = form.querySelector("[data-bag-count]");
    const bagDecrease = form.querySelector("[data-bag-decrease]");
    const bagIncrease = form.querySelector("[data-bag-increase]");
    const feedback = form.querySelector("[data-mix-feedback]");
    const defaultAddLabel = itemNoun === "item" ? "Add to cart" : itemNoun === "box" ? "Add box to cart" : "Add bag to cart";
    const pluralItemNoun = itemNoun === "item" ? "items" : itemNoun === "box" ? "boxes" : "bags";
    // Keep unfinished picker drafts within this tab; only Shopify's cart persists across visits.
    const storageKey = unlimitedPicks
      ? `jazzis-shopify-christmas-mix-v1-${form.dataset.productHandle}`
      : "jazzis-shopify-mix-draft-v3";
    let busy = false;
    let storageOK = true;
    let bagQuantity = 1;
    let cartSubtotalCents = Number(form.dataset.cartSubtotalCents || 0);
    let cartCurrency = form.dataset.cartCurrency || form.dataset.currency || document.body.dataset.currency || "CAD";
    const addButtonLabel = () => bagQuantity === 1 ? defaultAddLabel : `Add ${bagQuantity} ${pluralItemNoun} to cart`;
    const selected = () => size.selectedOptions[0];
    const capacity = () => Number(selected()?.dataset.capacity || 0);
    const limits = () => ({
      min: Number(selected()?.dataset.min || 1),
      max: unlimitedPicks ? maxChristmasPicks : Number(selected()?.dataset.max || Infinity),
      unlimited: unlimitedPicks
    });
    const selections = () => rows.map(row => Math.max(0, Number.parseInt(row.dataset.quantity || "0", 10) || 0));
    const selectedCount = choices => choices.reduce((total, quantity) => total + quantity, 0);
    const names = Object.fromEntries(rows.map((row, i) => [String(i), row.dataset.name]));
    function updateCompactShipping(currentItemSubtotalCents = 0) {
      if (!shippingNode || !shippingMessage || !shippingCompactMessage || !shippingMeter || !shippingFill || !shippingProgress) return;
      const locale = document.body.dataset.locale || document.documentElement.lang || "en-CA";
      const offer = shippingProgress.getOffer(document.body.dataset.country || "CA", shippingNode.dataset);
      const threshold = shippingProgress.getThresholdMinor(
        offer,
        cartCurrency,
        document.body.dataset.shopCurrency || "CAD",
        window.Shopify?.currency?.rate,
        locale
      );
      const projectedSubtotalCents = cartSubtotalCents + Math.max(0, Number(currentItemSubtotalCents) || 0);
      const calculation = shippingProgress.calculate(projectedSubtotalCents, threshold);
      if (!calculation) {
        shippingNode.hidden = true;
        return;
      }
      const { remaining, percent, unlocked } = calculation;
      const format = amount => shippingProgress.formatMoney(amount, cartCurrency, locale);
      shippingNode.hidden = false;
      shippingMessage.textContent = unlocked
        ? `FREE ${offer.region} Shipping unlocked!`
        : `You're only ${format(remaining)} away from FREE ${offer.region} Shipping!`;
      shippingCompactMessage.textContent = unlocked
        ? "FREE shipping unlocked!"
        : `${format(remaining)} to FREE shipping`;
      shippingMeter.setAttribute("aria-valuenow", String(percent));
      shippingMeter.setAttribute("aria-label", `Progress toward free ${offer.region} shipping`);
      shippingMeter.setAttribute(
        "aria-valuetext",
        unlocked
          ? `Free ${offer.region} shipping unlocked; ${format(projectedSubtotalCents)} spent of ${format(threshold)}`
          : `${format(projectedSubtotalCents)} spent of ${format(threshold)} toward free ${offer.region} shipping`
      );
      shippingFill.style.width = `${percent}%`;
      shippingNode.title = unlocked
        ? `Free ${offer.region} shipping unlocked; ${format(projectedSubtotalCents)} spent of ${format(threshold)}`
        : `${format(projectedSubtotalCents)} spent of ${format(threshold)} for free ${offer.region} shipping`;
    }
    function syncCartSubtotal(event) {
      const cart = event.detail;
      const subtotal = Number(cart?.items_subtotal_price);
      if (!Number.isFinite(subtotal)) return;
      cartSubtotalCents = Math.max(0, subtotal);
      if (cart.currency) cartCurrency = cart.currency;
      refresh();
    }
    ["jazzis:cart-changed", "jazzis:cart-updated", "jazzis:cart-added"].forEach(name =>
      document.addEventListener(name, syncCartSubtotal)
    );
    function save() {
      try {
        const choices = selections();
        window.sessionStorage.setItem(storageKey, JSON.stringify({
          variant: size.value,
          quantity: bagQuantity,
          ids: rows.flatMap((row, index) => Array.from({ length: choices[index] }, () => row.dataset.id))
        }));
      } catch {
        if (storageOK) { feedback.textContent = "This browser may not restore your picks if you reload."; storageOK = false; }
      }
    }
    function refresh() {
      const sizeLabel = form.querySelector("[data-mix-size-label]");
      const choices = selections();
      const count = selectedCount(choices);
      const bubsCount = rows.reduce((total, row, index) =>
        total + (row.dataset.surchargePerChoice === "1" ? choices[index] : 0), 0);
      const pricedBubsCount = bubsCount;
      const currentVariant = selected();
      const matchesPriceTier = option => option?.value && (!unlimitedPicks || !option.disabled) &&
        Number(option.dataset.bubsCount || 0) === pricedBubsCount &&
        (!boxStyle || option.dataset.boxStyle === boxStyle.value) && matchesProductOptions(option);
      const bubsVariant = !currentVariant?.value
        ? null
        : matchesPriceTier(currentVariant)
          ? currentVariant
          : [...size.options].find(matchesPriceTier);
      const variantMissing = !bubsVariant;
      if (!variantMissing) size.value = bubsVariant.value;
      const selectedVariant = selected();
      const cap = Number(selectedVariant?.dataset.capacity || 0);
      const { min, max } = limits();
      const currentItemUnitCents = Number(selectedVariant?.dataset.priceCents);
      const currentItemSubtotalCents = count > 0 && !variantMissing && Number.isFinite(currentItemUnitCents)
        ? currentItemUnitCents * bagQuantity
        : 0;
      updateCompactShipping(currentItemSubtotalCents);
      const searchQuery = (search?.value || "").trim().toLocaleLowerCase();
      const remainingToMinimum = Math.max(0, min - count);
      const priceLabel = variantMissing
        ? `Bag price not set for ${pricedBubsCount} Bubs ${pricedBubsCount === 1 ? "choice" : "choices"}`
        : `${selectedVariant?.dataset.label} · ${selectedVariant?.dataset.price}`;
      if (sizeLabel) sizeLabel.textContent = priceLabel || "Choose a bag from the bag page";
      // Shopify's variant tier already includes the Bubs surcharge; use its current-market price.
      if (priceSummary) {
        priceSummary.textContent = variantMissing
          ? `Price unavailable for this ${itemNoun} selection`
          : `Total per ${itemNoun}: ${selectedVariant.dataset.price}`;
      }
      if (designImage && designCaption && boxStyle) {
        const imageVariant = bubsVariant || [...size.options].find(option =>
          option.dataset.boxStyle === boxStyle.value && matchesProductOptions(option));
        const imageUrl = imageVariant?.dataset.designImage || "";
        const designName = boxStyle.value;
        designImage.hidden = !imageUrl;
        designImage.alt = `${designName} design`;
        if (imageUrl && designImage.getAttribute("src") !== imageUrl) designImage.src = imageUrl;
        if (!imageUrl) designImage.removeAttribute("src");
        designCaption.textContent = imageUrl ? `${designName} design` : `${designName} — photo not available yet`;
      }
      if (totalOutput) {
        const cents = Number(selectedVariant?.dataset.priceCents);
        totalOutput.textContent = variantMissing || !Number.isFinite(cents)
          ? "Unavailable for this selection"
          : new Intl.NumberFormat(document.documentElement.lang || "en-CA", {
              style: "currency",
              currency: form.dataset.currency || "CAD",
              currencyDisplay: "code"
            }).format(cents * bagQuantity / 100);
      }
      if (addPrice) {
        addPrice.textContent = variantMissing ? "" : (selectedVariant?.dataset.priceCompact || selectedVariant?.dataset.price || "");
        addPrice.hidden = variantMissing || !addPrice.textContent;
      }
      if (add) {
        const accessiblePrice = variantMissing ? "" : (selectedVariant?.dataset.price || "");
        add.setAttribute("aria-label", accessiblePrice
          ? `${addButtonLabel()}, ${accessiblePrice} per ${itemNoun}`
          : addButtonLabel());
      }
      if (progress) {
        progress.max = Math.max(1, min);
        progress.value = Math.min(count, min);
      }
      if (portionsCopy) {
        portionsCopy.textContent = cap
          ? `${count}/${Number.isFinite(max) ? max : min} portions`
          : "0 portions";
      }
      if (progressCopy) {
        progressCopy.textContent = unlimitedPicks && cap
          ? `${count}/${maxChristmasPicks} portions`
          : !cap
          ? "Choose a bag first."
          : remainingToMinimum > 0
            ? `Choose ${min}${Number.isFinite(max) && max > min ? `–${max}` : ""} portions · ${count}/${min}`
            : Number.isFinite(max) && max > min
              ? `Ready to add · ${count} portions`
              : `Ready to add · ${count} of ${min} picked`;
      }
      status.textContent = !cap ? `Choose a ${itemNoun} size to start.` :
        unlimitedPicks ? `${count}/${maxChristmasPicks} candy portions selected. Choose 1 to ${maxChristmasPicks} portions in total; repeated picks count toward the total. We'll portion your choices to fill your item.` :
        limits().min === 5 ? `${count} of 5 candy choices selected. ${count < 5 ? `Choose ${5 - count} more — exactly 5 required for the ${itemNoun === "box" ? "Halloween box" : "½ lb bag"}.` : count > 5 ? `Remove ${count - 5} to keep exactly 5.` : "Ready to add — all 5 candies selected."}` :
        limits().min === 4 ? `${count} of 8 candy choices selected. Choose 4 to 8 candies for your Snackle Box.${count < 4 ? ` Choose at least ${4 - count} more.` : count > 8 ? " Remove choices to keep no more than 8." : ""}` :
        limits().min > 1 && limits().max === limits().min ? `${count} of ${limits().min} candy choices selected. ${count < limits().min ? `Choose ${limits().min - count} more — exactly ${limits().min} required for this ${itemNoun}.` : count > limits().max ? `Remove ${count - limits().max} to keep exactly ${limits().max}.` : `Ready to add — exactly ${limits().max} candies selected.`}` :
        limits().min > 1 ? `${count} candy choices selected. ${count < limits().min ? `Choose ${limits().min - count} more — ${limits().min} candy choices required for this ${itemNoun}.` : "Ready to add — your required candy choices are selected."}` :
        !count ? "Choose at least one candy. Your choices will be portioned to fill your bag." :
        `${count} candy ${count === 1 ? "choice" : "choices"} chosen. We'll portion your picks to fill your bag.`;
      status.textContent += ` Each selected Bubs candy adds CA$1 to the ${itemNoun} price.`;
      if (unlimitedPicks && count > maxChristmasPicks) status.textContent += ` Remove ${count - maxChristmasPicks} candy portions before adding to cart.`;
      if (variantMissing) status.textContent += ` The ${itemNoun} needs an available Shopify price variant for ${pricedBubsCount} Bubs choices.`;
      if (surchargeNote) {
        if (variantMissing && bubsCount > 0) {
          surchargeNote.textContent = `This ${itemNoun} does not have an available price variant for ${bubsCount} Bubs ${bubsCount === 1 ? "choice" : "choices"} yet.`;
        } else if (unlimitedPicks && bubsCount > 0) {
          surchargeNote.textContent = `${bubsCount} Bubs ${bubsCount === 1 ? "portion" : "portions"} · surcharge included in the item price`;
        } else if (bubsCount > 0) {
          const currency = form.dataset.currency || "CAD";
          const cents = Number(form.dataset.bubsSurchargeCents || 100) * bubsCount;
          const formatted = new Intl.NumberFormat(document.documentElement.lang || "en-CA", {
            style: "currency",
            currency
          }).format(cents / 100);
          surchargeNote.textContent = `${bubsCount} Bubs ${bubsCount === 1 ? "choice" : "choices"} · ${formatted} added to the ${itemNoun} price`;
        } else {
          surchargeNote.textContent = `Each selected Bubs candy adds CA$1 to the ${itemNoun} price.`;
        }
      }
      add.disabled = busy || !model.evaluate(cap, choices, limits()).valid || variantMissing;
      price.textContent = cap && !variantMissing ? `Whole ${itemNoun}: ${selectedVariant.dataset.price}` : "";
      summary.replaceChildren();
      if (selectedPicks) selectedPicks.hidden = !cap;
      let visibleRowCount = 0;
      rows.forEach((row, i) => {
        const quantity = choices[i];
        const decrease = row.querySelector("[data-mix-decrease]");
        const increase = row.querySelector("[data-mix-increase]");
        const output = row.querySelector("[data-mix-count]");
        const outOfStock = row.dataset.outOfStock === "true";
        if (decrease) decrease.disabled = busy || outOfStock || !cap || quantity === 0;
        if (increase) increase.disabled = busy || outOfStock || !cap || count >= max;
        row.disabled = busy || outOfStock || !cap || count >= max;
        row.setAttribute("aria-label", `${outOfStock ? "Out of stock: " : "Add one "}${row.dataset.name}${row.dataset.surchargePerChoice === "1" ? " (+$1)" : ""}${quantity ? `; ${quantity} portions selected` : ""}`);
        if (output) output.textContent = String(quantity);
        const matchesSearch = !searchQuery || row.dataset.name.toLocaleLowerCase().includes(searchQuery);
        row.hidden = Boolean(searchQuery) && !matchesSearch && quantity === 0;
        if (!row.hidden) visibleRowCount += 1;
        row.classList.toggle("has-grams", quantity > 0);
        for (let portion = 0; portion < quantity; portion += 1) {
          const slot = document.createElement("div");
          slot.className = "mix-pick-slot is-filled";
          slot.dataset.candyId = row.dataset.id;
          slot.setAttribute("role", "listitem");
          slot.setAttribute("title", row.dataset.name);
          const remove = document.createElement("button");
          remove.type = "button";
          remove.className = "mix-pick-remove";
          remove.disabled = busy;
          remove.setAttribute("aria-label", `Remove one portion of ${row.dataset.name}`);
          remove.addEventListener("click", () => {
            adjustCandy(row, -1);
            summary.querySelector(".mix-pick-remove")?.focus?.();
          });
          const photoSrc = row.querySelector(".mix-sweet-photo")?.getAttribute("src");
          if (photoSrc) {
            const photo = document.createElement("img");
            photo.setAttribute("src", photoSrc);
            photo.setAttribute("alt", row.dataset.name);
            remove.append(photo);
          } else {
            const name = document.createElement("span");
            name.textContent = row.dataset.name;
            remove.append(name);
          }
          slot.append(remove);
          summary.append(slot);
        }
      });
      const slotCount = cap ? Math.max(count, Number.isFinite(max) ? max : min) : 0;
      for (let index = count; index < slotCount; index += 1) {
        const slot = document.createElement("div");
        slot.className = "mix-pick-slot";
        slot.setAttribute("role", "listitem");
        slot.setAttribute("aria-label", `Empty portion ${index + 1} of ${slotCount}`);
        summary.append(slot);
      }
      if (emptyResults) {
        emptyResults.hidden = visibleRowCount > 0;
        emptyResults.textContent = "No matches. Try another search.";
      }
      if (bagQuantityOutput) bagQuantityOutput.textContent = String(bagQuantity);
      if (bagDecrease) bagDecrease.disabled = busy || bagQuantity <= 1;
      if (bagIncrease) bagIncrease.disabled = busy || bagQuantity >= 99;
      if (addLabel && !busy) addLabel.textContent = addButtonLabel();
      size.disabled = busy;
      if (bagTypeSwitch) bagTypeSwitch.disabled = busy;
      form.querySelector("[data-mix-reset]").disabled = busy || !count;
    }
    try {
      const saved = JSON.parse(window.sessionStorage.getItem(storageKey) || "null");
      if (saved && Array.isArray(saved.ids) && (unlimitedPicks || saved.ids.length <= 250) &&
          saved.ids.every(id => typeof id === "string")) {
        if (Number.isInteger(saved.quantity) && saved.quantity >= 1 && saved.quantity <= 99) {
          bagQuantity = saved.quantity;
        }
        const option = [...size.options].find(option => option.value === saved.variant);
        if (option) {
          size.value = option.value;
          if (boxStyle && option.dataset.boxStyle) boxStyle.value = option.dataset.boxStyle;
          restoreProductOptions(option);
        }
        let remaining = limits().max;
        rows.forEach(row => {
          if (row.dataset.outOfStock === "true") {
            row.dataset.quantity = "0";
            return;
          }
          const quantity = saved.ids.filter(id => id === row.dataset.id).length;
          // Keep older Christmas mixes visible so customers can remove extras
          // themselves rather than silently discarding saved selections.
          const restored = unlimitedPicks ? quantity : Math.min(quantity, remaining);
          row.dataset.quantity = String(restored);
          remaining -= restored;
        });
      }
    } catch { /* Ignore malformed or inaccessible drafts; never change Shopify's cart. */ }
    // The clicked bag in the page URL wins over a previously saved draft's size.
    const requestedVariant = form.dataset?.requestedVariant;
    if (requestedVariant) {
      const option = [...size.options].find(option => option.value === requestedVariant);
      size.value = option ? option.value : "";
      if (boxStyle && option?.dataset.boxStyle) boxStyle.value = option.dataset.boxStyle;
      restoreProductOptions(option);
    }
    search?.addEventListener("input", refresh);
    bagTypeSwitch?.addEventListener("change", () => {
      if (bagTypeSwitch.value) {
        save();
        window.location.assign(bagTypeSwitch.value);
      }
    });
    size.addEventListener("change", () => { refresh(); save(); });
    boxStyle?.addEventListener("change", () => { refresh(); save(); });
    productOptions.forEach(control => control.addEventListener("change", () => { refresh(); save(); }));
    function revealAddedPick(row) {
      const addedPick = [...summary.querySelectorAll(".mix-pick-slot.is-filled")]
        .filter(slot => slot.dataset.candyId === row.dataset.id).pop();
      if (!addedPick) return;
      const viewport = summary.getBoundingClientRect();
      const pick = addedPick.getBoundingClientRect();
      let left = summary.scrollLeft;
      if (pick.right > viewport.right) left += pick.right - viewport.right + 2;
      else if (pick.left < viewport.left) left += pick.left - viewport.left - 2;
      else return;
      // Scroll only the picks strip, never the page or the candy list.
      summary.scrollTo({
        left: Math.max(0, left),
        behavior: window.matchMedia?.("(prefers-reduced-motion: reduce)")?.matches ? "auto" : "smooth"
      });
    }
    function adjustCandy(row, delta) {
        if (busy || row.dataset.outOfStock === "true") return;
        if (!capacity()) return;
        const quantity = Math.max(0, Number.parseInt(row.dataset.quantity || "0", 10) || 0);
        const choices = selections();
        const count = selectedCount(choices);
        if (delta > 0 && count >= limits().max) return;
        if (delta < 0 && quantity === 0) return;
        row.dataset.quantity = String(quantity + delta);
        refresh();
        if (delta > 0) revealAddedPick(row);
        save();
    }
    rows.forEach(row => {
      row.addEventListener("click", () => adjustCandy(row, 1));
      // Support cached markup from the previous theme version during an update.
      row.querySelector("[data-mix-decrease]")?.addEventListener("click", event => {
        event?.stopPropagation?.();
        adjustCandy(row, -1);
      });
      row.querySelector("[data-mix-increase]")?.addEventListener("click", event => {
        event?.stopPropagation?.();
        adjustCandy(row, 1);
      });
    });
    const adjustBagQuantity = delta => {
      if (busy) return;
      bagQuantity = Math.max(1, Math.min(99, bagQuantity + delta));
      refresh();
      save();
    };
    bagDecrease?.addEventListener("click", () => adjustBagQuantity(-1));
    bagIncrease?.addEventListener("click", () => adjustBagQuantity(1));
    form.querySelector("[data-mix-reset]").addEventListener("click", () => {
      rows.forEach(row => { row.dataset.quantity = "0"; });
      feedback.textContent = "";
      refresh(); save();
    });
    form.addEventListener("submit", async event => {
      event.preventDefault();
      if (busy) return;
      feedback.textContent = "";
      let payload;
      const quantityToAdd = bagQuantity;
      try {
        if (!size.value) throw new Error(`Choose a ${itemNoun} style.`);
        const choices = selections();
        const bubsCount = rows.reduce((total, row, index) =>
          total + (row.dataset.surchargePerChoice === "1" ? choices[index] : 0), 0);
        if (unlimitedPicks && selectedCount(choices) > maxChristmasPicks) throw new Error(`Choose no more than ${maxChristmasPicks} candy portions per item.`);
        const variant = [...size.options].find(option => option.value === size.value);
        const pricedBubsCount = bubsCount;
        if (!variant || (unlimitedPicks && variant.disabled) || Number(variant.dataset.bubsCount || 0) !== pricedBubsCount ||
            (boxStyle && variant.dataset.boxStyle !== boxStyle.value) || !matchesProductOptions(variant)) {
          throw new Error(`This ${itemNoun}'s price for ${pricedBubsCount} Bubs ${pricedBubsCount === 1 ? "choice" : "choices"} is not set up yet.`);
        }
        const properties = model.properties(capacity(), choices, names, limits(), itemNoun);
        if (boxStyle) properties[unlimitedPicks ? "Design" : "Box style"] = boxStyle.value;
        productOptions.forEach(control => { properties[control.dataset.optionName] = control.value; });
        payload = { items: [{ id: size.value, quantity: quantityToAdd, properties }] };
      } catch (error) { feedback.textContent = error.message; return; }
      busy = true; refresh(); if (addLabel) addLabel.textContent = "Adding your mix…"; else add.textContent = "Adding your mix…"; form.setAttribute("aria-busy", "true");
      let added = false;
      try {
        const response = await fetch(`${root}cart/add.js`, {
          method: "POST", headers: { Accept: "application/json", "Content-Type": "application/json" }, body: JSON.stringify(payload)
        });
        const result = await response.json();
        if (!response.ok || result.status >= 400) throw new Error(typeof result.description === "string" ? result.description : "This size is unavailable. Please choose another.");
        added = true;
        rows.forEach(row => { row.dataset.quantity = "0"; });
        bagQuantity = 1;
        refresh();
        save();
        const cartResponse = await fetch(`${root}cart.js`, { cache: "no-store", headers: { Accept: "application/json" } });
        if (!cartResponse.ok) throw new Error("Your bag was added, but the cart total could not refresh. Open your cart to review it before adding again.");
        const cart = await cartResponse.json();
        document.dispatchEvent(new CustomEvent("jazzis:cart-updated", { detail: cart }));
        document.dispatchEvent(new CustomEvent("jazzis:cart-added", { detail: cart }));
        feedback.textContent = quantityToAdd === 1
          ? `Your custom ${itemNoun} is in your cart. The picker is ready for a new mix.`
          : `${quantityToAdd} custom ${pluralItemNoun} are in your cart. The picker is ready for a new mix.`;
      } catch (error) {
        feedback.textContent = error instanceof TypeError
          ? "We could not confirm the cart update. Open your cart before trying again to avoid adding twice."
          : error.message;
        if (added) document.dispatchEvent(new CustomEvent("jazzis:cart-stale"));
      } finally {
        busy = false; if (addLabel) addLabel.textContent = addButtonLabel(); else add.textContent = addButtonLabel(); form.removeAttribute("aria-busy"); refresh();
      }
    });
    refresh();
  });
})();
